import React from 'react';
export default function () {
  return /*#__PURE__*/React.createElement("link", {
    href: "https://cdn.watermarkinsights.com/css/1.6.0/tokens.css",
    rel: "stylesheet"
  });
}